import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { rememberCampaignSource } from "@/lib/api";
import {
  initAnalyticsFromStoredConsent,
  trackPageView,
} from "@/lib/analytics";
import Nav from "@/components/Nav";
import AuthModal from "@/components/AuthModal";
import ConsentBanner from "@/components/ConsentBanner";
import HomePage from "@/pages/Home";
import ExplorePage from "@/pages/Explore";
import MessagePage from "@/pages/Message";
import ImpactPage from "@/pages/Impact";
import GlobalImpactPage from "@/pages/GlobalImpact";
import CreatePage from "@/pages/Create";
import AdminPage from "@/pages/Admin";
import UnderReviewPage from "@/pages/UnderReview";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPage from "@/pages/Privacy";
import TermsPage from "@/pages/Terms";
import CookiesPage from "@/pages/Cookies";
import SupportPage from "@/pages/Support";
import WhyVoihuPage from "@/pages/WhyVoihu";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  useEffect(() => { rememberCampaignSource(); }, []);
  // On boot, re-arm Google Consent Mode from any previously stored
  // opt-in so returning visitors don't see the banner again. Runs
  // once; the banner handles first-time decisions.
  useEffect(() => { initAnalyticsFromStoredConsent(); }, []);
  // SPA page-view tracking. GA4 `config` is created with
  // send_page_view: false in lib/analytics.js so every page_view —
  // including the very first — is emitted here. trackPageView() is a
  // no-op until consent is granted, so this hook is safe to run on
  // every route regardless of consent state.
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/message/:id" element={<MessagePage />} />
        <Route path="/message/:id/impact" element={<ImpactPage />} />
        <Route path="/message/:id/global-impact" element={<GlobalImpactPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/account/under-review" element={<UnderReviewPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/why-voihu" element={<WhyVoihuPage />} />
      </Routes>
      <AuthModal />
      <ConsentBanner />
      <Toaster position="top-center" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
